module.exports = __webpack_public_path__ + "static/media/about_image.90615f96.jpg";